module.exports = __webpack_public_path__ + "images/backgrounds/subtle-irongrip.c9f15836db29df79c2a0.png";